import script from "./ChartHorizontal.vue?vue&type=script&setup=true&lang=js"
export * from "./ChartHorizontal.vue?vue&type=script&setup=true&lang=js"

import "./ChartHorizontal.vue?vue&type=style&index=0&id=67177ad6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67177ad6"]])

export default __exports__